module.exports = __webpack_public_path__ + "static/img/user-01.0e8ad35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-01.png
// module id = Yqxd
// module chunks = 1